import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { adminLogin, onErrorStopLoad } from "../../redux/slices/auth";
import { useNavigate, Link } from "react-router-dom";
import { useAuthSelector } from "../../redux/selector/auth";
import * as Images from "../../utilities/images";
import { toast } from "react-toastify";

const Login = () => {
  document.title = "Login";
  const toastId = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = useAuthSelector();
  const { loading } = authData;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);

  // show only one toast at one time
  const showToast = (msg) => {
    if (!toast.isActive(toastId.current)) {
      toastId.current = toast.error(msg);
    }
  };

  // Form submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      showToast("Please enter your email");
      return;
    } else if (
      email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email,
      )
    ) {
      showToast("Please enter valid email address");
      return;
    } else if (!password) {
      showToast("Please enter your password");
      return;
    }
    let params = {
      email: email.trim(),
      password: password,
      role: "admin, administrator",
    };
    dispatch(
      adminLogin({
        ...params,
        cb(ress) {
          if (ress.status === 200) {
            navigate("/dashboard");
          }
        },
      }),
    );
  };

  // toggle password confirmation
  const handleTogglePassword = () => {
    setTogglePassword(!togglePassword);
  };

  // stop loader on page load
  useEffect(() => {
    dispatch(onErrorStopLoad());
  }, [dispatch]);

  return (
    <>
      <div className="auth-bg-all">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 hey-admin-inner">
              <div className="hey-admin-inner">
                <h1 className="hey-title m-0">Hey👋</h1>
              </div>
              {/* <p className="admin-text-welcome">Welcome</p> */}
              <p className="admin-text">Admin</p>
            </div>
            <div className="col-lg-6">
              <div className="auth-outer-fields">
                <div className="text-center">
                  <img
                    className="mt-5"
                    alt="company-logo"
                    src={Images.brandLogo}
                  />
                </div>
                <div className="form-outer">
                  <div className="auth-heading-form">
                    <h1>Login</h1>
                    <p>Please enter your login details</p>
                  </div>
                  <form
                    onSubmit={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    <div className="input-container text-filed-outer">
                      <input
                        type="text"
                        className="input-fileds"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <img
                        className="input-images"
                        src={Images.Message}
                        alt="lock"
                      />
                    </div>
                    <div className="input-container text-filed-outer mt-3">
                      <input
                        type={togglePassword ? "text" : "password"}
                        className="input-fileds"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                      <img
                        onClick={handleTogglePassword}
                        className="input-images-password"
                        src={
                          togglePassword ? Images.hidePassword : Images.showeye
                        }
                        alt="eye-icon-lock"
                      />
                    </div>

                    <div className="remember-me-checkbox justify-content-end">
                      {/* <div className="d-flex align-items-center">
                        <input
                          className="remmeber-checkbox"
                          id="login"
                          type="checkbox"
                        />
                        <label className="remember-me mb-0" htmlFor="login">
                          Remember me
                        </label>
                      </div> */}
                      <Link to="/forgot-password" className="forgot-heading">
                        Forgot password?
                      </Link>
                    </div>
                    <div>
                      <button
                        disabled={loading}
                        className="auth-submit-button"
                        type="submit"
                      >
                        Log In &nbsp;&nbsp;
                        {loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
